import Component from './InDmCard.vue'
export default Component
export * from './types'
